import type { FC, PropsWithChildren, ReactNode } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import { isHydrated } from '../../utils/utils';

interface ClientOnlyProps {
    hideBelowTheFold?: boolean;
    skeleton?: ReactNode;
}

export const ClientOnly: FC<PropsWithChildren<ClientOnlyProps>> = ({
    children,
    hideBelowTheFold,
    skeleton,
}) => {
    if (!isHydrated()) return null;

    return hideBelowTheFold ? (
        <BelowTheFold skeleton={skeleton}>{children}</BelowTheFold>
    ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>{children}</>
    );
};
ClientOnly.defaultProps = {
    hideBelowTheFold: undefined,
    skeleton: undefined,
};

interface BelowTheFoldProps {
    skeleton: ReactNode;
}

const BelowTheFold: FC<PropsWithChildren<BelowTheFoldProps>> = ({ children, skeleton }) => {
    const { ref, isIntersecting } = useIntersectionObserver({
        freezeOnceVisible: true,
        rootMargin: '0px 0px 200px 0px',
        threshold: 0,
    });

    if (!isIntersecting) {
        return (
            <div ref={ref} className="w-full">
                {skeleton ?? null}
            </div>
        );
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};
